module.exports = __webpack_public_path__ + "static/media/higuchi-building-7.f03c9a77.jpg";